import { Box } from "@chakra-ui/react";
import React, { memo, PropsWithChildren } from "react";
import colors from "app/colors";

interface IProps extends PropsWithChildren {
  color: string;
  transition?: string;
}

const MessageAvatarHeader: React.FC<IProps> = ({
  color,
  transition,
  children,
}) => (
  <Box w="52px" backgroundColor={color} transition={transition}>
    <Box borderColor={colors.white} borderWidth={8} borderBottomLeftRadius={20}>
      <Box backgroundColor={colors.white}>{children}</Box>
    </Box>
  </Box>
);

export default memo(MessageAvatarHeader);
